import { selectProfile, selectRequestingChangePlan } from '../../../../../store/workspace/selectors';
import { requestChangePlanThunk } from '../../../../../store/workspace/thunks';
import { setChangePlanModal } from '../../../../../store/workspace/slice';
import { purchasePlanDialogue } from '../../../../../configs/payment';
import { useDispatch, useSelector } from '../../../../../store/store';
import TextArea from '../../../../../components/TextArea';
import { LayerIcon } from '../../../../../assets/icons';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import styles from './style.module.scss';
import { useState } from 'react';


export default function ChangePlan() {
    const dispatch = useDispatch();
    const profile = useSelector(selectProfile);
    const [message, setMessage] = useState('');
    const isLoading = useSelector(selectRequestingChangePlan)

    const confirmFunc = () => {
        const body = {
            message,
            action: 'sales',
            email: profile?.email,
            subject: 'Change Plan',
            company: profile?.companyName,
            name: `${profile?.firstName} ${profile?.lastName}`,
        };

        dispatch(requestChangePlanThunk(body));
    };

    return (
        <Modal
            size='sm'
            icon={<LayerIcon />}
            title='Upgrade plan'
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setChangePlanModal(false))}
        >
            <div className={styles.contact_sales}>
                <p>{purchasePlanDialogue.ChangePlan}</p>
                <span>You can write your message here:</span>
                <TextArea label='Message' value={message} onChange={setMessage} />
            </div>
            <div className={styles.actions}>
                <Button
                    type='Outline-Primary'
                    text='Cancel'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setChangePlanModal(false))}
                />
                <Button
                    type='Primary'
                    text='Confirm'
                    disabled={!message}
                    loading={isLoading}
                    onClick={confirmFunc}
                    className={styles.actions_btn}
                />
            </div>
        </Modal>
    )
};
